module.exports = __webpack_public_path__ + "img/print-logo.26a16e52.png";